import { Create } from '@fund/api-modules';
// import { getApiHostWithoutEnv } from '@fund/api-host';
import CreateByUser from './decorator/CreateByUser';

import QuestionModel from '../model/question.model';
import TransformResponse from './decorator/TransformResponse';

@CreateByUser({
  getUserParams: (userInfo) => {
    const {
      utoken,
      ctoken,
      uid,
      deviceid,
      passportid,
    } = userInfo;
    return {
      utoken,
      ctoken,
      deviceid,
      passportid,
      customerNo: uid,
      userid: uid,
      mobileKey: deviceid,
      product: 'EFund',
      plat: 'web',
    };
  },
})

@Create({
  baseURL: 'https://jijinbaapi.eastmoney.com',
  // getApiHostWithoutEnv('jijinbaapi'), // 更多地址参考 https://acttest.1234567.com.cn/topic/2019/fund-config/api
  params: {
    deviceid: '1234567.py.service',
    version: '6.5.5',
    appVersion: '6.5.5',
    product: 'EFund',
    plat: 'web',
  },
})

class JijinbaApi {
  @TransformResponse((res) => {
    console.log('');
    return {
      Data: QuestionModel.objectArrayWithKeyValuesArray(res.Data.QuestionTopList || []),
      VarietyDynamicStatistics: res.Data.VarietyDynamicStatistics,
      PostCount: res.Data.PostCount,
    };
  })
  getQuestion(FCODE) {
    // https://dataapineice.1234567.com.cn/gongce/community/show/fundPageMoreInfoSp1?product=EFund&userid=123&deviceid=123&plat=web&ctoken=123&utoken=123&version=6.2.0&FundCode=000001
    // https://jijinbaapi.eastmoney.com/FundMCApi/FundMBNew/FundBarInfo?CToken=njqq11junk6nhd6ekjfccujeucaj8fad&PassportID=1010285265217684&version=6.2.6&plat=Iphone&product=EFund&ServerVersion=6.2.5&scene=detail&UToken=dhchhnhkhdqa68ud66-fhqhejafku6-n&deviceid=E26A0636-7DEF-43B1-B7FD-D00BA09B8150&GTOKEN=6995CE0E88064C6F84885C735B3AD18f&UserID=43fe14e102644bd5b0edcd8fc3306e80&fundCode=000001
    return this.GET('/community/show/fundPageMoreInfoSp1', {
      FundCode: FCODE,
      scene: 'detail',
    }, {
      baseURL: 'https://uni-fundts.1234567.com.cn',
    });
  }

  getFundbarList(FCODE) {
    return this.GET('/community/fundBar/getFundBarAllList', {
      fundCode: FCODE,
      pageSize: 8,
      sort: 1,
      timePoint: 0,
    }, {
      baseURL: 'https://uni-fundts.1234567.com.cn',
    });
  }

  setCancelLikePost(PostId) {
    return this.GET('/FundMCApi/FundMBNew/CancelLikePost', {
      postid: PostId,
    });
  }

  setLikePost(PostId) {
    return this.GET('/FundMCApi/FundMBNew/LikePost', {
      postid: PostId,
    });
  }
}
export default new JijinbaApi();
